import { MDCDialog } from '@material/dialog';
import { GravyBinder } from 'gravy-bind';
import list, { List } from 'postcss/lib/list';
import { FarmhandMcw } from './farmhand-mcw';
import { QuoteProductLine } from './models/quoting/QuoteProductLine';
import { goToQuote } from './utils/go-to-quote';
import { onReady } from './utils/on-ready';

declare var forceMobile: boolean;
declare var farmhandMcw: FarmhandMcw;
declare var availableLines: any;
declare var bundleableLines: any;
declare var widthBreak: number;
declare global {
    interface Window { mlq: any; }
}
export class MultilineQuote {
    productLinesTouched: boolean = false;
    selectLine: string = '';
    agentCode: string = '';
    subProducerAgentId: string = '';
    public apAcids: string = '';
    public selectedLine: QuoteProductLine;
    public dialogBinder: GravyBinder;
    public formBinder: GravyBinder;
    public campaignCode: string = '';

    constructor() {
        const dialog = document.getElementsByClassName('multiquote-bundle-dialog')[0] as HTMLDivElement;
        if (dialog)
            this.dialogBinder = new GravyBinder(this, dialog);
        const form = document.getElementsByClassName('multiquote-form')[0] as HTMLFormElement;
        if (form) {
            this.formBinder = new GravyBinder(this, form);
            this.formBinder.updateBindings();
        }

        onReady(this.initialize);
        const campaignCodeElement = document.getElementById('CampaignCode') as HTMLInputElement;
        this.campaignCode = campaignCodeElement?.value || '';
        const subProducerCodeElement = document.getElementById('SubProducerAgentId') as HTMLInputElement;
        this.subProducerAgentId = subProducerCodeElement?.value || '';
    }

    private initialize = (): void => {
        this.handleApSelection();
    }

    private handleApSelection = (): void => {
        if (this.apAcids !== 'null') {
            let acidArray = this.apAcids.split(";");

            if (acidArray.length > 1) {
                //Randomize the selection.
                var randomNumber = Math.floor(Math.random() * acidArray.length)

                this.agentCode = acidArray[randomNumber].replace(/"/g, "");
            }
            else {
                this.agentCode = acidArray[0].replace(/"/g, "");
            }
        }
    }

    canSubmit = (): boolean => this.getSelectedLines().length > 0;

    getSelectedLines = (): number[] => {
        const getSelectValue = (): number[] => this.selectLine ? [parseInt(this.selectLine)] : [];

        if (forceMobile === true || !this.isUsingChips()) {
            return getSelectValue();
        }

        const chipIds = ['0', '2', '1', '4', '3', '5', '6', '7'];
        let chipsSelected = [];

        chipIds.forEach((id) => {
            const line = document.getElementById(id);
            if (line?.classList?.contains('mdc-chip--selected')) {
                chipsSelected.push(parseInt(id));
            }
        });

        return chipsSelected;
    }

    onProductLineChanged = (selectedLineId: string): void => {

        // map id to product line name
        const productLineNames = {
            '0': 'Auto',
            '1': 'Renters',
            '2': 'Home',
            '3': 'AutoRenters',
            '4': 'AutoHome',
            '5': 'Life',
            '6': 'Business',
            '7': 'Farm and Crop',
        };
        const selectedLine = productLineNames[selectedLineId];

        // get all product lines
        const autoLine = document.getElementById('0');
        const homeLine = document.getElementById('2');
        const rentersLine = document.getElementById('1');
        const autoHomeLine = document.getElementById('4');
        const autoRentersLine = document.getElementById('3');
        const lifeLine = document.getElementById('5');
        const businessLine = document.getElementById('6');
        const farmCropLine = document.getElementById('7');

        function removeClasses(line) {
            line?.classList?.remove('mdc-chip--selected');
            line?.classList?.remove('selected');
        }

        switch (selectedLine) {
            case 'Home':
                removeClasses(rentersLine);
                removeClasses(autoHomeLine);
                removeClasses(autoRentersLine);
                break;
            case 'Renters':
                removeClasses(homeLine);
                removeClasses(autoHomeLine);
                removeClasses(autoRentersLine);
                break;
            case 'AutoRenters':
            case 'AutoHome':
                removeClasses(autoLine);
                removeClasses(homeLine);
                removeClasses(rentersLine);

                if (selectedLine === 'AutoRenters') {
                    removeClasses(autoHomeLine);
                } else if (selectedLine === 'AutoHome') {
                    removeClasses(autoRentersLine);
                }

                break;
            case 'Auto':
                removeClasses(autoHomeLine);
                removeClasses(autoRentersLine);
                break;
            case 'Home':

            case 'Renters':
                removeClasses(autoHomeLine);
                removeClasses(autoRentersLine);
                break;
            case 'Life':
            case 'Business':
            case 'Farm and Crop':
                removeClasses(autoLine);
                removeClasses(homeLine);
                removeClasses(rentersLine);
                removeClasses(autoHomeLine);
                removeClasses(autoRentersLine);
                break;
        }
    };

    private updateOutwardBindings = (): void => {
        this.formBinder?.updateOutwardBindings();
        this.dialogBinder?.updateOutwardBindings();
    }

    getSelectedLineName = (): string => {
        const defaultText = 'Selected product';
        const selectedLines = this.getSelectedLines();
        if (selectedLines.length === 1) {
            const lineId = selectedLines[0];
            if (!lineId && lineId !== 0)
                return defaultText;
            return availableLines[lineId] || defaultText;
        }
        return defaultText;
    };

    submit = (): void => {
        const selectedLines = this.getSelectedLines();
        if (selectedLines.length === 1 && bundleableLines.includes(selectedLines[0])) {
            this.showBundleDialog(selectedLines[0]);
        } else {
            this.goToQuotePage(selectedLines);
        }
    };

    showBundleDialog = (product: QuoteProductLine): void => {
        this.selectedLine = product;
        this.formBinder.updateBindings();
        this.dialogBinder.updateOutwardBindings();
        const dialog = MDCDialog.attachTo(document.querySelector('.multiquote-bundle-dialog'));
        dialog.open();
    };

    handleSubmit = (event: Event): void => {
        event.preventDefault();
        this.productLinesTouched = true;
        this.updateOutwardBindings();
        let referralCode = new URLSearchParams(window.location.search).get('referralCode');
        let agentId = new URLSearchParams(window.location.search).get('agentId');
        if (!this.canSubmit()) {
            return;
        }
        this.submit();
    };

    goToQuotePage = (businessLines: QuoteProductLine[]): void => {
        (document.querySelector(".linear-progress") as HTMLElement).style.display = "grid";
        (document.querySelector(".mdc-dialog__scrim") as HTMLElement).style.zIndex = "2";
        let referralCode = new URLSearchParams(window.location.search).get('referralCode');
        let agentId = new URLSearchParams(window.location.search).get('agentId');

        if (this.campaignCode) {
            goToQuote(businessLines, this.agentCode, referralCode, agentId, this.subProducerAgentId, this.campaignCode);
        } else {
            goToQuote(businessLines, this.agentCode, referralCode, agentId, this.subProducerAgentId);
        }
    };

    isUsingChips = (): boolean => Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > widthBreak && forceMobile == false;

    // handle field switching on resize
    watchWindowSize = (): void => window.addEventListener('resize', () => this.updateOutwardBindings());
}
